import { IMoveArticlesOperation } from './i-move-articles-operation';
import { UndoAttachArticlesOperation } from './undo-attach-articles-operation';
import { UndoDetachArticlesOperation } from './undo-detach-articles-operation';
import { Dictionary } from 'typescript-collections';
import { Vector3 } from 'three';
import { UndoReplaceArticleOperation } from './undo-replace-article-operation';
import { InsertArticleUtils } from '@project/components/article/util/insert-article-utils';

export class UndoReplaceArticlesByLocationOperation extends UndoReplaceArticleOperation implements IMoveArticlesOperation {
  private _moveArticlesMap: Dictionary<string, Vector3>;

  constructor(
    attachOperation: UndoAttachArticlesOperation,
    detachOperation: UndoDetachArticlesOperation,
    moveArticlesMap: Dictionary<string, Vector3>,
    private insertArticleUtils: InsertArticleUtils
  ) {
    super(attachOperation, detachOperation);
    this._moveArticlesMap = moveArticlesMap;
  }

  public getMoveArticlesMap(): Dictionary<string, Vector3> {
    return this._moveArticlesMap;
  }

  public isArticlesOrderChanged(): boolean {
    return false;
  }

  public isDistanceBetweenArticlesChanged(): boolean {
    return true;
  }

  public async performUndo(): Promise<void> {
    this.insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, true);
    await super.performUndo();
  }

  public async performRedo(): Promise<void> {
    this.insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, false);
    await super.performRedo();
  }

  public getQualifiedClassName(): string {
    return 'UndoReplaceArticlesByLocationOperation';
  }
}
